import Client from './Clients/AxiosClient'
const resource = '/homeAppointments'

export default {
  get(params = {}) {
    return Client.get(resource, { params })
  },
  update(payload, id) {
    return Client.patch(`${resource}/${id}`, payload)
  },
}
